import { Container } from "@material-ui/core";
import * as React from "react";
import { Typography, Card, CardActions } from "@material-ui/core";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Logo from '../images/logo.png';

const useStyles = makeStyles((theme) => ({
    pageDiv: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        height: '100%',
        width: '100%',
        textAlign: 'center',
    },
    logoDiv: {
        height: 200,
        width: 200
    },
    pageTitle: {
        marginTop: 20,
    },
}));

const HomePage = () => {
    const classes = useStyles();

    return (
        <Container style={{height: '90vh', width: '100vw'}}>
            <div className={classes.pageDiv}>
                <Card style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', width: '50%', margin: 'auto', backgroundColor: 'white'}} elevation={0}>
                    <img style={{ "margin": "50px auto", "display": "block", "width": "60%", }} src={Logo} alt='logo' />
                    <CardActions style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center',}}>
                        <Typography variant='overline'>Copyright Global Green Chemicals PLC. 2021</Typography>
                    </CardActions>
                </Card>
            </div>
        </Container>
)}
export default HomePage;